import QrReader from 'react-qr-reader';
import {
  Message,
  Image,
  Header,
  Segment,
  Button,
  Icon,
  Form,
  Divider,
} from 'semantic-ui-react';
import { v4 as uuid } from 'uuid';
import { useStore } from '../../../../app/stores/store';
import { useParams } from 'react-router-dom';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import agent from '../../../../app/api/agent';
import { FileUploadInterface } from '../../../../app/models/Profile';
import CameraModal from '../../../../app/common/modals/CameraModal';
import { observer } from 'mobx-react-lite';
import SpeechRecognition, {
  useSpeechRecognition,
} from 'react-speech-recognition';
import { ReactMic } from 'react-mic';
import { toast } from 'react-toastify';

function UserDetails({
  error,
  setError,
  userDetails,
  setUserDetails,
  assetDetails,
  setAssetDetails,
  submitHandler,
}: {
  assetDetails: {
    id: string;
    name: string;
    image: string;
    receiver: string;
    currentTask: string;
    currentSubtask: string;
    workflowStatus: string;
    receiverStatus: string;
    handovertype: string;
  };
  setAssetDetails: any;
  userDetails: any;
  setUserDetails: any;
  error: {
    message: string;
    camera: boolean;
  };
  setError: Dispatch<
    SetStateAction<{
      message: string;
      camera: boolean;
    }>
  >;
  submitHandler: (payload: any) => void;
}) {
  const { dashboardStore, userStore, commonStore } = useStore();

  const { id } = useParams<{ id: string }>();

  const { transcript } = useSpeechRecognition();

  const [responseData, setResponseData] = useState<FileUploadInterface[] | any>(
    [],
  );
  const [record, setrecord] = useState(false);
  const [message, setMessage] = useState<any>('');
  const [camImage, setCamImage] = useState<FileUploadInterface[]>([]);
  const [isItemScanned, setIsItemScanned] = useState(false);

  useEffect(() => {
    setCamImage(dashboardStore.dashboard.camImageUrl);
    // eslint-disable-next-line
  }, [dashboardStore.dashboard.camImageUrl]);

  useEffect(() => {
    (async () => {
      if (id) {
        let result = await agent.Account.details(id);

        if (result.displayName) {
          setUserDetails({
            name: result.displayName,
            image: result.image,
          });
        }
      }
    })();
    // eslint-disable-next-line
  }, [id]);

  const onStop = async (recordedBlob: any) => {
    let audiodata: FileUploadInterface[] = [];
    if (commonStore.devEnv) {
      const item = assetDetails?.id;
      const workLevel = dashboardStore.dashboard.dashboardWorkLevelMaster?.id;
      const response = await agent.Files.localFileUpload(
        recordedBlob.blob,
        workLevel,
        item,
      );
      const url = response?.data.path.replace(/\\\\/g, '\\');
      const filename = url.substring(url.lastIndexOf('\\') + 1);
      audiodata = [
        {
          fileId: uuid(),
          id: response.data.id,
          url: url,
          fileName: filename,
        },
      ];
    } else {
      const response = await agent.Files.uploadCameraImage(recordedBlob.blob);
      audiodata = [
        {
          fileId: uuid(),
          id: response.data.id,
          url: response.data.url,
          fileName: response.data.fileName,
        },
      ];
    }
    setResponseData(audiodata);
  };

  const startRecording = () => {
    SpeechRecognition.startListening({
      language: 'en-US',
      continuous: true,
    });
    setrecord(true);
  };

  const stopRecording = () => {
    SpeechRecognition.stopListening();
    setrecord(false);
  };

  if (!SpeechRecognition.browserSupportsSpeechRecognition()) {
    toast.info('Browser not supported');
  }

  const handleError = () => {
    setError({
      ...error,
      camera: true,
      message: '',
    });
  };

  const handleScan = async (data: string | null) => {
    if (data) {
      let params = {
        itemId: data || '',
        scanUserId: id || '',
      };
      let result = await agent.Activities.assetScan(params);
      if (typeof result?.data === 'string') {
        toast.error(result?.data);
        return;
      }
      setAssetDetails(result?.data);
      setIsItemScanned(true);
    }
  };

  const clearHandler = (index: number) => {
    let images = [...camImage];
    images.splice(index, 1);
    dashboardStore.dashboard.camImageUrl = images;
  };

  const handleSubmit = () => {
    if (userStore.user?.id === id) {
      toast.error('The scanned user should not match the current user');
      return;
    }

    let payload = {
      id: uuid(),
      appUserId: id,
      username: userDetails?.name,
      dateTime: new Date().toISOString(),
      status: `Assigned User ${userDetails.name} Successfully for this ${assetDetails.name}`,
      comments: message || transcript,
      files: responseData,
      photos: camImage,
    };
    submitHandler(payload);
    dashboardStore.dashboard.camImageUrl = [];
  };

  return (
    <div style={{ marginTop: '20px', paddingBottom: '12px' }}>
      {dashboardStore.dashboard.openCameraModal ? (
        <CameraModal nameData="assignuser" />
      ) : null}
      <Message info content="Please scan the Asset for handing over to user" />
      <Image
        style={{ margin: 'auto' }}
        src={userDetails.image || '/assets/user.png'}
        size="tiny"
        circular
      />
      <Header style={{ marginTop: '10px' }} textAlign="center" as="h2">
        {userDetails.name}
      </Header>
      {isItemScanned ? (
        <div style={{ display: 'grid', justifyContent: 'center' }}>
          <Icon name="check" size="massive" color="green" />
          <Button
            primary
            onClick={() => {
              setIsItemScanned(false);
              setAssetDetails({
                id: '',
                name: '',
                image: '',
                receiver: '',
                currentTask: '',
                currentSubtask: '',
                workflowStatus: '',
                receiverStatus: '',
                handovertype: '',
                removeUserId: '',
              });
            }}
          >
            Rescan
          </Button>
        </div>
      ) : (
        <QrReader
          delay={300}
          onError={handleError}
          onScan={handleScan}
          style={{ width: '100%' }}
          facingMode="environment"
        />
      )}
      <div
        style={{
          display: 'grid',
          justifyContent: 'center',
          padding: '20px',
          border: '1px solid #cfcfcf',
          borderRadius: '10px',
          margin: '20px 0',
        }}
      >
        <div
          style={{
            display: 'flex',
            gap: '14px',
            justifyContent: 'space-between',
            marginBottom: '12px',
            overflowY: 'auto',
            width: '100%',
          }}
        >
          {camImage.length === 0 ? (
            <>
              <Image
                style={{ width: 'calc(33% - 7px)' }}
                src={'/assets/thumbnail.png'}
                size="tiny"
              />
              <Image
                style={{ width: 'calc(33% - 7px)' }}
                src={'/assets/thumbnail.png'}
                size="tiny"
              />
              <Image
                style={{ width: 'calc(33% - 14px)' }}
                src={'/assets/thumbnail.png'}
                size="tiny"
              />
            </>
          ) : (
            <>
              {camImage.map((url, index) => (
                <div style={{ position: 'relative', maxWidth: '94px' }}>
                  <Image key={url.id} src={url.url} alt="images" />
                  <Icon
                    name="close"
                    style={{
                      position: 'absolute',
                      right: '-3px',
                      top: '0px',
                      background: '#00000054',
                      color: 'white',
                      width: '20px',
                      height: '19px',
                    }}
                    onClick={() => clearHandler(index)}
                  />
                </div>
              ))}
            </>
          )}
        </div>
        <Button
          style={{ width: '100%', minWidth: '200px' }}
          primary
          onClick={() => dashboardStore.setOpenCameraModal(true)}
        >
          Add Images
        </Button>
      </div>
      <Form>
        <Form.TextArea
          label="Comments"
          placeholder="Please Specify a reason"
          maxLength="500"
          name="comments"
          value={message || transcript}
          onChange={(e) => setMessage(e.target.value)}
        />
      </Form>
      <Divider horizontal>Or</Divider>
      <Segment style={{ marginLeft: '5px' }} className="mic-second-screen">
        <ReactMic
          record={record}
          onStop={onStop}
          strokeColor="#000000"
          backgroundColor="#faf8f7"
          className="canvas"
        />
        {record ? (
          <Icon
            className="voice-recorder-start-icon"
            circular
            size="large"
            name="stop circle outline"
            onClick={stopRecording}
            disabled={!record}
          />
        ) : (
          <Icon
            className="voice-recorder-stop-icon"
            circular
            size="large"
            name="microphone"
            onClick={startRecording}
            disabled={record}
          />
        )}
        <audio
          className="voice-recorder-play"
          src={responseData.map((a: any) => a?.url)}
          controls
        />
      </Segment>
      <Button
        disabled={assetDetails.id?.length === 0}
        onClick={handleSubmit}
        color="teal"
        style={{ marginBottom: '10px !important', width: '100%' }}
      >
        Submit
      </Button>
    </div>
  );
}

export default observer(UserDetails);
